import React from "react";
import resume from "../content/resume";

/**
 * Render a description that may contain a `{placeholder}` token linking out
 * to an external URL. Mirrors the logic in Services.jsx.
 */
const renderDesc = (entry) => {
  if (!entry.link) return entry.desc;
  const parts = entry.desc.split(entry.link.placeholder);
  return (
    <>
      {parts[0]}
      <a
        href={entry.link.url}
        target="_blank"
        rel="noopener noreferrer"
        data-analytics-event={entry.link.analyticsEvent}
      >
        {entry.link.text}
      </a>
      {parts[1]}
    </>
  );
};

const Card = ({ value, darkTheme }) => (
  <div
    className={
      "bg-white  rounded p-4 mb-4 " +
      (darkTheme ? "bg-dark" : "bg-white border")
    }
  >
    <p className="badge bg-primary text-2 fw-400">{value.yearRange}</p>
    <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
      {value.title}
    </h3>
    <p className={darkTheme ? "text-primary" : "text-danger"}>{value.place}</p>
    <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
      {renderDesc(value)}
    </p>
    {value.highlights && value.highlights.length > 0 && (
      <ul
        className={
          "mt-2 mb-0 small " + (darkTheme ? "text-white-50" : "text-muted")
        }
      >
        {value.highlights.map((h, i) => (
          <li key={i} className="mb-1">
            {h}
          </li>
        ))}
      </ul>
    )}
  </div>
);

const Resume = ({ classicHeader, darkTheme }) => {
  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Summary
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gx-5">
          {/* Selected Experience */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              Selected Experience
            </h2>
            {resume.experience.map((value, index) => (
              <Card key={index} value={value} darkTheme={darkTheme} />
            ))}
            {resume.experienceFootnote && (
              <p
                className={
                  "text-center fst-italic small mt-2 " +
                  (darkTheme ? "text-white-50" : "text-muted")
                }
              >
                {resume.experienceFootnote}
              </p>
            )}
          </div>
          {/* Speaking & Community */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              Speaking &amp; Community
            </h2>
            {resume.speaking.map((value, index) => (
              <Card key={index} value={value} darkTheme={darkTheme} />
            ))}
            {/* Certifications */}
            <h2
              className={
                "text-6 fw-600 mb-4 mt-5 " + (darkTheme ? "text-white" : "")
              }
            >
              Certifications
            </h2>
            {resume.certifications.map((value, index) => (
              <Card key={index} value={value} darkTheme={darkTheme} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
